var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7553 12.0672C17.31 12.0672 19.381 9.9962 19.381 7.44149C19.381 4.88679 17.31 2.8158 14.7553 2.8158C12.2006 2.8158 10.1296 4.88679 10.1296 7.44149C10.1296 9.9962 12.2006 12.0672 14.7553 12.0672ZM11.0547 16.6929C7.9891 16.6929 5.50391 19.1781 5.50391 22.2437C5.50391 24.2875 7.1607 25.9443 9.20446 25.9443H20.3061C22.3499 25.9443 24.0067 24.2875 24.0067 22.2437C24.0067 19.1781 21.5215 16.6929 18.4559 16.6929H11.0547Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9971 7.4415C10.9971 5.36581 12.6797 3.68312 14.7554 3.68312C16.8311 3.68312 18.5138 5.36581 18.5138 7.4415C18.5138 9.5172 16.8311 11.1999 14.7554 11.1999C12.6797 11.1999 10.9971 9.5172 10.9971 7.4415ZM14.7554 1.94849C11.7217 1.94849 9.26242 4.40779 9.26242 7.4415C9.26242 10.4752 11.7217 12.9345 14.7554 12.9345C17.7891 12.9345 20.2485 10.4752 20.2485 7.4415C20.2485 4.40779 17.7891 1.94849 14.7554 1.94849ZM11.0549 15.8256C7.51023 15.8256 4.63672 18.6991 4.63672 22.2437C4.63672 24.7665 6.68182 26.8116 9.20459 26.8116H20.3063C22.829 26.8116 24.8742 24.7665 24.8742 22.2437C24.8742 18.6991 22.0006 15.8256 18.456 15.8256H11.0549ZM6.37136 22.2437C6.37136 19.6571 8.46824 17.5602 11.0549 17.5602H18.456C21.0426 17.5602 23.1395 19.6571 23.1395 22.2437C23.1395 23.8085 21.871 25.077 20.3063 25.077H9.20459C7.63984 25.077 6.37136 23.8085 6.37136 22.2437Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.81717ad5d459458196b31a05cfe1657d.svg";
export { ForwardRef as ReactComponent };